import { render, staticRenderFns } from "./commonStudentSimple.vue?vue&type=template&id=e8b4bfe0&scoped=true"
import script from "./commonStudentSimple.vue?vue&type=script&lang=js"
export * from "./commonStudentSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b4bfe0",
  null
  
)

export default component.exports